/**
 * @author       grady@zumper.com (Grady Kuhnline <gradykuhnline>)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Special file for allowing us to use perf_hooks in node and global.performance
 *               in the browser.
 */

// NOTE: node implements the exact same API as browsers do for performance but it does not set it
// as a global. Not all browsers support performance. In order to decorate our code with
// performance measurements we need to use this special file. It contains special comments that
// will be stripped out by webpack for server and client builds respectively. It contains a noop
// shim for browsers that do not natively support the performance api.

let performance
let PerformanceObserver

/* server-only:start */
const perfHooks = require('perf_hooks')
performance = perfHooks.performance
PerformanceObserver = perfHooks.PerformanceObserver
/* server-only:end */

/* client-only:start */
const noop = () => undefined
performance = global.performance || {
  clearMarks: noop,
  mark: noop,
  measure: noop,
}
PerformanceObserver =
  global.PerformanceObserver ||
  function () {
    this.observe = this.disconnect = this.takeRecords = noop
  }
/* client-only:end */

const performanceBegin = (taskName) => {
  try {
    performance.mark(`BEGIN_${taskName}`)
  } catch (e) {
    // swallow the error
  }
}

const performanceEnd = (taskName, info) => {
  try {
    performance.mark(`END_${taskName}`)
    const name = JSON.stringify({ ...info, taskName })
    performance.measure(name, `BEGIN_${taskName}`, `END_${taskName}`)
    performance.clearMarks(`BEGIN_${taskName}`)
    performance.clearMarks(`END_${taskName}`)
  } catch (e) {
    // swallow the error
  }
}

export { PerformanceObserver, performance, performanceBegin, performanceEnd }
